import {
  Stack,
  Typography,
  useTheme
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useContactsSelected, useRolesModifications } from '../../store'
import { SideContent } from './PreviewStyles'
import Synchronize from './ActionSynchronize'
import RolesManagement from './ActionRolesManagement'
import useFilters from '../../store'

const Header = ({ isForSync }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const [contactsSelected, setContactsSelected] = useContactsSelected()
  const [, setRolesModifications] = useRolesModifications()
  const navigate = useNavigate()
  
  const getTitle = () => {
    return isForSync 
      ? t('auth.card_in_mass.title')
      : t('auth.card_in_mass.roles_title', 'Modification des fonctionnalités')
  }

  const handleClose = () => {
    setContactsSelected([])
    setRolesModifications({})
    navigate('/contacts/list')
  }

  return (
    <Stack justifyContent={'space-between'} direction={'row'} width={'100%'}>
      <Stack direction={'row'} gap={1}>
        <Stack
          sx={{
            width: 32,
            height: 32,
            borderRadius: 16,
            backgroundColor: '#DBE8FE',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          <i className={'fa-solid fa-list-check'} style={{ color: theme.palette.primary.main }} />
        </Stack>
        <Stack>
          <Typography component={'span'} sx={{ fontSize: 10 }}>
            {t('auth.card_in_mass.count', { count: contactsSelected.length })}
          </Typography>
          <Typography component={'span'} sx={{ fontSize: 14, fontWeight: 600 }}>
            {getTitle()}
          </Typography>
        </Stack>
      </Stack>
      <i
        className={'fa-light fa-xmark'}
        style={{cursor: 'pointer'}}
        onClick={handleClose}
      />
    </Stack>
  )
}

const CardInMass = ({ onRefetch }) => {
  const [filters] = useFilters()
  
  const isForSync = filters.sync.length === 1 && filters.sync.includes('not_sync')

  return (
    <SideContent style={{ width: 420, minHeight: 0 }}>
      <Stack
        gap={3}
        flex={1}
        sx={{
          minHeight: 0,
          height: '100%',
          border: '1px solid #EFEFEF',
          borderRadius: '24px',
          backgroundColor: 'white',
          boxSizing: 'border-box',
          overflow: 'hidden',
          p: 3
        }}
      >
        <Header isForSync={isForSync} />
        <Stack flex={1} minHeight={0}>
          {isForSync ? (
            <Synchronize onRefetch={onRefetch} />
          ) : (
            <RolesManagement onRefetch={onRefetch} />
          )}
        </Stack>
      </Stack>
    </SideContent>
  )
}

export default CardInMass